<script>
    export let size = 'default'
    export let name = null
    export let type = 'default'
    const sizeDirective = {
        default: 64,
        small: 32,
        medium: 90,
    }
    const typeDirective = {
        default: {
            'border-color': 'var(--color-brand-primary-01)',
            color: '#752127',
            background: 'var(--color-grey-150)',
        },
        flat: {
            'border-color': '#FFFFFF',
            color: '#C21B17',
            background: '#FFFFFF',
        },
    }
    $: ini = name
        ? name
              .toUpperCase()
              .split(' ')
              .map((c) => c[0])
              .slice(0, 2)
              .join('')
        : ''
    $: _type = type in typeDirective ? type : 'default'
    $: styleText = `
        <style>
          text {
              font: normal 35px sans-serif;
              fill: ${typeDirective[_type].color};
              user-select: none;
            }
        </style>`
    $: style = Object.entries(typeDirective[_type])
        .map(([k, v]) => `${k}: ${v}`)
        .join(';')
</script>

<div
    style={`width: ${sizeDirective[size]}px; height: ${sizeDirective[size]}px;`}
>
    <svg
        viewBox="0 0 80 80"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        style="fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2;"
    >
        {@html styleText}
        <circle
            cx="50%"
            cy="50%"
            r="38"
            stroke-width="4"
            fill={typeDirective[_type].background}
            stroke={typeDirective[_type]['border-color']}
        ></circle>
        <!-- <circle cx="50%" cy="50%" r="38" stroke-width="5%" fill="transparent" stroke={typeDirective[_type]['border-color']}/> -->
        <text x="50%" y="50%" dominant-baseline="central" text-anchor="middle"
            >{ini}</text
        >
        <!-- {#if name}
        {:else}
          <g>
            <g>
                <path d="M344,144c-3.92,52.87 -44,96 -88,96c-44,0 -84.15,-43.12 -88,-96c-4,-55 35,-96 88,-96c53,0 92,42 88,96Zm-16.302,-1.208c-3.253,43.873 -35.185,80.862 -71.698,80.862c-36.507,-0 -68.502,-36.965 -71.697,-80.84c-3.264,-44.889 28.44,-78.468 71.697,-78.468c43.251,0 74.962,34.379 71.698,78.446Z" style="fill:#752127;"/>
            </g>
            <g>
                <path d="M80.57,396.35c33.056,-60.6 104.673,-92.35 175.43,-92.35c72.688,0 146.284,33.507 177.893,97.47c-36.597,32.582 -82.403,54.948 -133.038,62.53l-81.616,0c-53.221,-8.171 -101.174,-32.357 -138.669,-67.65Zm21.027,-3.143c32.592,-48.265 94.011,-72.861 154.403,-72.861c62.182,0 125.483,26.073 157.099,77.289c-32.175,25.725 -70.975,43.431 -113.449,50.014c-0.033,0.005 -79.142,0.005 -79.142,0.005c-44.869,-7.122 -85.687,-26.391 -118.91,-54.446l-0.001,-0.001Z" style="fill:#752127;"/>
            </g>
          </g>
        {/if} -->
    </svg>
</div>

<style>
    div {
        /* border-width: 2px;
        border-radius: 50%; */
        position: relative;
        display: flex;
        justify-content: center;
        align-items: center;
    }
</style>
